import ServerErrorPage from './ServerErrorPage';

export default ServerErrorPage;
